import { DragDropManagerImpl } from './classes/f5f47b7d13d5b07c2c87604751ccc1d931ef096de7433666e8697dc1a5f6daf6.cfe-internal.js';
import { createStore } from '../../../redux/es/8ba47f83901a523089ad36b6d4a5fb9920c2d58ea10de9a9e26907275fa7efc1.cfe-internal.js';
import { reduce } from './reducers/6ae354d4f96c83db1048f7f42d6d423c32235b648829e1d4541b0d248cfd69d2.cfe-internal.js';
import { DragDropMonitorImpl } from './classes/9f1a0b406d3c1ce84c1c02fe4a30fb79185b8362bcd4e90a231b51eec66eeebf.cfe-internal.js';
import { HandlerRegistryImpl } from './classes/30083911d174325bfa463e1f3e25849eccce9b480490e39f752e3146588d1f85.cfe-internal.js';

function createDragDropManager(backendFactory) {
  var globalContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var backendOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var debugMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var store = makeStoreInstance(debugMode);
  var monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
  var manager = new DragDropManagerImpl(store, monitor);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}
function makeStoreInstance(debugMode) {
  // TODO: if we ever make a react-native version of this,
  // we'll need to consider how to pull off dev-tooling
  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, debugMode && reduxDevTools && reduxDevTools({
    name: 'dnd-core',
    instanceId: 'dnd-core'
  }));
}

export { createDragDropManager };
